"use client";

import { List, Grid } from "lucide-react";
import { formatNumber } from "@/lib/utils";
import { useEffect, useState } from "react";

type Props = {
    sort: "part" | "newest";
    setSort: (value: "part" | "newest") => void;

    totalProducts: number;
    totalItems: number;

    showCategory: boolean;
    setShowCategory: (value: boolean) => void;

    showAll: boolean;
    setShowAll: (value: boolean) => void;

    showProductSkuDecoded: boolean;
    setShowProductSkuDecoded: (value: boolean) => void;
};

export default function FilterBar({
                                      sort,
                                      setSort,
                                      totalItems,
                                      showCategory,
                                      setShowCategory,
                                      showAll,
                                      setShowAll,
                                      showProductSkuDecoded,
                                      setShowProductSkuDecoded
                                  }: Props) {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("token");
        setIsLoggedIn(!!token);
    }, []);

    return (
        <div className="flex flex-wrap items-center justify-between gap-4 mb-3 flex-col lg:flex-row lg:items-center bg-white shadow-sm p-3 rounded-lg">

            {/* SORT */}
            <div className="flex items-center gap-2">
                <span className="text-sm">
                    مرتب سازی براساس:
                </span>
                <button
                    type="button"
                    onClick={() => setSort("part")}
                    className={`rounded px-3 py-1 transition ${
                        sort === "part"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-200 hover:bg-gray-300 cursor-pointer"
                    }`}
                >
                    پارت نامبر
                </button>
                <button
                    type="button"
                    onClick={() => setSort("newest")}
                    className={`rounded px-3 py-1 transition ${
                        sort === "newest"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-200 hover:bg-gray-300 cursor-pointer"
                    }`}
                >
                    جدیدترین
                </button>
            </div>

            {/* OPTIONS */}
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                <div className="ml-4 text-sm font-bold">
                    {formatNumber(totalItems) } محصول
                </div>

                {/* CATEGORY TOGGLE */}
                <div className="flex items-center gap-2">
                    <span className="text-sm">
                        نمایش دسته بندی
                    </span>
                    <button
                        type="button"
                        onClick={() => setShowCategory(!showCategory)}
                        className={`flex h-6 w-12 cursor-pointer items-center rounded-full p-1 transition ${
                            showCategory
                                ? "bg-green-500 hover:bg-green-400"
                                : "bg-gray-300 hover:bg-gray-400"
                        }`}
                    >
                        <div
                            className={`h-4 w-4 rounded-full bg-white shadow-md transition-transform ${
                                showCategory
                                    ? "-translate-x-6"
                                    : ""
                            }`}
                        />
                    </button>
                </div>

                {/* SHOW ALL TOGGLE - only for logged-in users */}
                {isLoggedIn && (
                    <div className="flex items-center gap-2">
                        <span className="text-sm">
                            نمایش همه محصولات
                        </span>
                        <button
                            type="button"
                            onClick={() => setShowAll(!showAll)}
                            className={`flex h-6 w-12 cursor-pointer items-center rounded-full p-1 transition ${
                                showAll
                                    ? "bg-green-500 hover:bg-green-400"
                                    : "bg-gray-300 hover:bg-gray-400"
                            }`}
                        >
                            <div
                                className={`h-4 w-4 rounded-full bg-white shadow-md transition-transform ${
                                    showAll
                                        ? "-translate-x-6"
                                        : ""
                                }`}
                            />
                        </button>
                    </div>
                )}

                {/* Sku Attr TOGGLE */}
                <div className="flex items-center gap-2">
                    <span className="text-sm">
                        نحوه نمایش:
                    </span>

                    <div className="flex overflow-hidden rounded-lg border border-gray-200">
                        <button
                            title={'نمایش شبکه‌ای'}
                            type="button"
                            onClick={() => setShowProductSkuDecoded(false)}
                            className={`flex items-center gap-2 px-3 py-2 text-sm transition cursor-pointer
                            ${
                                !showProductSkuDecoded
                                    ? "bg-blue-600 text-white"
                                    : "bg-white hover:bg-gray-100"
                            }`}
                        >
                            <Grid size={16} />
                        </button>

                        <button
                            title={'نمایش لیست گسترده'}
                            type="button"
                            onClick={() => setShowProductSkuDecoded(true)}
                            className={`flex items-center gap-2 px-3 py-2 text-sm transition border-r border-gray-200 cursor-pointer
                            ${
                                showProductSkuDecoded
                                    ? "bg-blue-600 text-white"
                                    : "bg-white hover:bg-gray-100"
                            }`}
                        >
                            <List size={16} />
                        </button>
                    </div>
                </div>
            </div>

        </div>
    );
}
